import {FormattedMessage} from "react-intl";
import PageTitle from "../../../components/WMS/Mobile/PageTitle";
import {useState} from "react";
import WmsMobileLayout from "../wmsMobileLayout";
import PackingOrderList from "./components/PackingOrderList";
import PackingToast from "./components/PackingToast";

function Packing() {

    // Toast
    const [openToast, setOpenToast] = useState(false)
    const [toastType, setToastType] = useState()

    const handleOpenToast = (type) => {
        setToastType(type)
        setOpenToast(true)
    }
    return(
        <WmsMobileLayout className="wms-test-component">
            <WmsMobileLayout.LeftHeader>
            </WmsMobileLayout.LeftHeader>
            <WmsMobileLayout.RightHeader>
            </WmsMobileLayout.RightHeader>

            <WmsMobileLayout.Content>
                <PageTitle
                    title={<FormattedMessage id={"wms.packing.pageTitle"}/>}
                    subtitle={<FormattedMessage id={"wms.packing.pageSubTitle"}/>}
                />

                {openToast && (
                    <PackingToast open={openToast} handleClose={() => setOpenToast(false)} type={toastType}/>
                )}

                <PackingOrderList/>
            </WmsMobileLayout.Content>
        </WmsMobileLayout>
    )
}

export default Packing;
